import React from 'react';

import { parseLocaleNumber } from 'Helpers/currencyFormat';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

export default function InputsEnvironmental(props) {
    const changeInput = (e, group, key) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = parseLocaleNumber(e.target.value);
        val = Number.isNaN(val) ? 0 : val;

        data[group][key] = val;
        props.changeHandler(data);
    };

    return (
        <div className="table__card">
            <h2 className="table__header tw-mb-6">{$t('Environmental')}</h2>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <tbody>
                        <tr>
                            <td className="tw-font-semibold" colSpan={4}>
                                {$t('Carbon Footprint')}
                            </td>
                        </tr>
                        <tr>
                            <td>{$t('Carbon Emissions (Tonnes CO2)')}</td>
                            <td>
                                <NumberFormat
                                    thousandSeparator={true}
                                    inputMode="numeric"
                                    className="text-input"
                                    value={props.data.carbon_footprint.carbon_emissions}
                                    onChange={(e) => {
                                        changeInput(e, 'carbon_footprint', 'carbon_emissions');
                                    }}
                                />
                            </td>
                            <td>{$t('Carbon Offset (Tonnes CO2)')}</td>
                            <td>
                                <NumberFormat
                                    thousandSeparator={true}
                                    inputMode="numeric"
                                    className="text-input"
                                    value={props.data.carbon_footprint.carbon_offset}
                                    onChange={(e) => {
                                        changeInput(e, 'carbon_footprint', 'carbon_offset');
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="tw-font-semibold" colSpan={4}>
                                {$t('Waste')}
                            </td>
                        </tr>
                        <tr>
                            <td>{$t('Waste Produced (Tonnes)')}</td>
                            <td>
                                <NumberFormat
                                    thousandSeparator={true}
                                    inputMode="numeric"
                                    className="text-input"
                                    value={props.data.waste.produced}
                                    onChange={(e) => {
                                        changeInput(e, 'waste', 'produced');
                                    }}
                                />
                            </td>
                            <td>{$t('% sent to landfill')}</td>
                            <td>
                                <div className="tw-relative after:tw-content-['%'] after:tw-absolute after:tw-right-2 after:tw-top-1/2 after:-tw-translate-y-1/2">
                                    <input
                                        className="text-input"
                                        type={'number'}
                                        value={props.data.waste.sent_to_landfill_percent}
                                        min="0"
                                        max="100"
                                        onChange={(e) => {
                                            changeInput(e, 'waste', 'sent_to_landfill_percent');
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
